import { Component } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { LoadingController, NavController, ToastController } from 'ionic-angular';
import { RhynoApiProvider } from '../../providers/rhyno-api/rhyno-api';
import { HomePage } from '../home/home';
import { LeistungDetailPage } from '../leistung-detail/leistung-detail';



@Component({
  selector: 'page-about',
  templateUrl: 'about.html'
})
export class AboutPage {
  Leistungen = [];
  filter = { verrechnet: "false" };
  mySearchInput = '';
  mySearchInput2 = '';
  loading: any;
  initLoad: boolean = true;


  constructor(public navCtrl: NavController,
    private rhynoApi: RhynoApiProvider,
    public loadingCtrl: LoadingController,
    private afAuth: AngularFireAuth,
    public toastCtrl: ToastController) {

    this.afAuth.authState.subscribe(user => {
      if (!user) {
        return
      }
      this.getData();
      this.getVersion();


    })



  }
  ionViewWillEnter() {
    if (this.initLoad == false) {
      this.getData();
    }
  }

  openPageMitarbeiterProject(item) {
    this.navCtrl.push(LeistungDetailPage, item);
  }

  doRefresh(refresher) {
    this.getData();
    refresher.complete();
  }

  getData() {
    this.loading = this.loadingCtrl.create({
      content: 'einen Moment...'
    });
    this.loading.present();

    this.rhynoApi.getLeistung({}).subscribe(
      data => {
        if (data.success) {
          this.Leistungen = data.data;
          console.log(data);
          this.initLoad = false;
        }
        this.loading.dismiss();
      },
      err => {
        console.log(err);
        this.loading.dismiss();

      },
      () => console.log('Leistungen Search Complete')
    );
  }

  new() {
    let data = {
      presettings: {
      }
    };
    this.navCtrl.push(HomePage, data);

  }

  getVersion() {
    this.rhynoApi.getVersion().subscribe(data => {
      if (data.version != 1) {
        this.presentToast('Es gibt eien neue Version, bitte die App aktualisieren');
      }
    }, error => {

    });

  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top',
      showCloseButton: false
    });
    toast.present();
  }


}



// WEBPACK FOOTER //
// ./src/pages/about/about.ts